import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetCountryService {

  constructor(private http: HttpClient) { }

  async getAllCountry() {
    try {
      let response = await this.http
        .get(`${appApiResources.getCountry}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }
}
